import { defineComponent as d, openBlock as a, createElementBlock as o, mergeProps as p, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as A } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, g = { key: 1 }, Z = { key: 2 }, f = { key: 3 }, k = { key: 4 }, C = { key: 5 }, c = {
  name: "ScalarIconLockSimpleOpen"
}, y = /* @__PURE__ */ d({
  ...c,
  props: {
    label: {},
    weight: {}
  },
  setup(V) {
    const H = V, { bind: r, weight: l } = m(H);
    return (s, t) => (a(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      i(s.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", u, t[0] || (t[0] = [
        n("path", { d: "M208,76H100V56a28,28,0,0,1,28-28c13.51,0,25.65,9.62,28.24,22.39a12,12,0,1,0,23.52-4.78C174.87,21.5,153.1,4,128,4A52.06,52.06,0,0,0,76,56V76H48A20,20,0,0,0,28,96V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V96A20,20,0,0,0,208,76Zm-4,128H52V100H204Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", g, t[1] || (t[1] = [
        n("path", {
          d: "M216,96V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H208A8,8,0,0,1,216,96Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M208,80H96V56a32,32,0,0,1,32-32c15.37,0,29.2,11,32.16,25.59a8,8,0,0,0,15.68-3.18C171.32,24.15,151.2,8,128,8A48.05,48.05,0,0,0,80,56V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,128H48V96H208V208Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", Z, t[2] || (t[2] = [
        n("path", { d: "M224,96V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V96A16,16,0,0,1,48,80H80V56A48.05,48.05,0,0,1,128,8c23.2,0,43.32,16.15,47.84,38.41a8,8,0,0,1-15.68,3.18C157.2,35,143.37,24,128,24A32,32,0,0,0,96,56V80H208A16,16,0,0,1,224,96Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", f, t[3] || (t[3] = [
        n("path", { d: "M208,82H94V56a34,34,0,0,1,34-34c16.3,0,31,11.69,34.12,27.19a6,6,0,0,0,11.76-2.38C169.55,25.48,150.26,10,128,10A46.06,46.06,0,0,0,82,56V82H48A14,14,0,0,0,34,96V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V96A14,14,0,0,0,208,82Zm2,126a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", k, t[4] || (t[4] = [
        n("path", { d: "M208,80H96V56a32,32,0,0,1,32-32c15.37,0,29.2,11,32.16,25.59a8,8,0,0,0,15.68-3.18C171.32,24.15,151.2,8,128,8A48.05,48.05,0,0,0,80,56V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,128H48V96H208V208Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", C, t[5] || (t[5] = [
        n("path", { d: "M208,84H92V56a36,36,0,0,1,36-36c17.24,0,32.75,12.38,36.08,28.8a4,4,0,1,0,7.84-1.6C167.78,26.81,149.31,12,128,12A44.05,44.05,0,0,0,84,56V84H48A12,12,0,0,0,36,96V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V96A12,12,0,0,0,208,84Zm4,124a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : A("", !0)
    ], 16));
  }
});
export {
  y as default
};
